import { BookingWidget } from "@/components/BookingWidget";
import { IMAGES } from "@/lib/constants";
import { Plane, ShieldCheck, Clock, BadgeCheck } from "lucide-react";

const AIRPORTS = ["Heathrow", "Gatwick", "Stansted", "Luton", "London City", "Manchester", "Birmingham", "Edinburgh", "Glasgow", "Bristol", "Liverpool", "Newcastle", "Leeds Bradford", "East Midlands", "Southampton", "Cardiff", "Aberdeen", "Belfast"];

export default function Airport() {
  return (
    <div>
      <section className="relative bg-navy">
        <img src={IMAGES.airport} alt="Airport" className="absolute inset-0 h-full w-full object-cover opacity-25" />
        <div className="absolute inset-0 bg-navy/70" />
        <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
          <div className="grid items-center gap-10 lg:grid-cols-12">
            <div className="lg:col-span-5">
              <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-medium text-white"><Plane size={14} className="text-brand" /> Airport Transfers</span>
              <h1 className="mt-4 font-heading text-4xl font-bold text-white lg:text-5xl">Airport transfers across the UK</h1>
              <p className="mt-4 max-w-md text-slate-300">Meet & greet, flight monitoring and fixed fares to and from every major UK airport. Your driver tracks your flight so a delay is never a problem.</p>
              <div className="mt-6 flex flex-wrap gap-5 text-sm text-slate-300">
                <span className="flex items-center gap-2"><BadgeCheck size={16} className="text-emerald-400" /> Flight monitoring</span>
                <span className="flex items-center gap-2"><ShieldCheck size={16} className="text-emerald-400" /> Meet & greet</span>
                <span className="flex items-center gap-2"><Clock size={16} className="text-emerald-400" /> Fixed fares</span>
              </div>
            </div>
            <div className="lg:col-span-7"><BookingWidget initialTab="airport" /></div>
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <h2 className="font-heading text-2xl font-bold text-navy">Airports we cover</h2>
        <div className="mt-6 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-4">
          {AIRPORTS.map((a) => (
            <div key={a} className="rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-navy">{a}</div>
          ))}
        </div>
      </section>
    </div>
  );
}
